import { render, staticRenderFns } from "./changeDelivary.vue?vue&type=template&id=c783289c"
import script from "./changeDelivary.vue?vue&type=script&lang=js"
export * from "./changeDelivary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports